// 用于存放全局状态，比如主题、菜单折叠、文档标题等
import { useState } from 'react';
export default () => {

    const [documentTitle, setDocumentTitle] = useState('Enjoy IFun'); // 后台标题
    const [refresh, setRefresh] = useState(0); // 刷新内页
    const [collapsed, setCollapsed] = useState(false); // 侧边栏折叠
    const [sideVis, setSideVis] = useState(true); // 侧边栏隐藏
    const [headVis, setHeadVis] = useState(true); // 头部隐藏

    return {
        documentTitle,
        setDocumentTitle,
        refresh,
        setRefresh,
        collapsed,
        setCollapsed,
        sideVis,
        setSideVis,
        headVis,
        setHeadVis,
    }
};
